// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/store';

export const getIsCartShowing = (state: ReduxStateShared) => state.ui.cart.isShowing;
